import { CollapseBlockHeader } from '../helperComponents';
import { MobileAccordionPrimary as MobileAccordionPrimaryComponent } from './MobileAccordionPrimary';
import { MobileAccordionSecondary as MobileAccordionSecondaryComponent } from './MobileAccordionSecondary';
import { MobileCollapseBlockPrimary } from './MobileCollapseBlockPrimary';
import { MobileCollapseBlockSecondary } from './MobileCollapseBlockSecondary';
export var MobileAccordionPrimary = MobileAccordionPrimaryComponent;
MobileAccordionPrimary.CollapseBlock = MobileCollapseBlockPrimary;
MobileAccordionPrimary.CollapseBlockHeader = CollapseBlockHeader;
export var MobileAccordionSecondary = MobileAccordionSecondaryComponent;
MobileAccordionSecondary.CollapseBlock = MobileCollapseBlockSecondary;
MobileAccordionSecondary.CollapseBlockHeader = CollapseBlockHeader;